import 'url-search-params-polyfill'


/**
 * Added By - Ramya Chinnadurai
 * Functionality - To search Url params based on the search key.
 * For polyfills npm module url-search-params are added
 * @param {*} searchKey - Key to search in url params
 */
const UrlSearchParams = (searchKey) => {
    var url = new URLSearchParams(window.location.search);
    var searchParam = url.get(searchKey);
    return searchParam;
};

export const UrlSearchParamsByKey = (searchKey, param) => {
    var url = new URLSearchParams(param);
    var searchParam = url.get(searchKey);
    return searchParam;
};

export const removeClass = (el, className) => {
    const hasClass = function (el, className){
        if (el.classList)
            return el.classList.contains(className);
        return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    }

	if (el.classList)
		el.classList.remove(className)
	else if (hasClass(el, className)){
		var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
		el.className = el.className.replace(reg, ' ');
	}
};

export default UrlSearchParams;

export const getParams = function (url) {
    const params = new URLSearchParams(url);
    let paramObj = {};
    for(var value of params.keys()) {
		let paramValue = params.get(value);
		if(value === "auid"){
			paramObj['affiliateID'] = paramValue;
		}else{
			paramObj[value] = paramValue;
		}
    }
    return paramObj;
};

export const loadScriptAsync = function(uri){
    return new Promise((resolve, reject) => {
        var tag = document.createElement('script');
        tag.src = uri;
        tag.async = true;
        tag.onload = () => {
            resolve();
        };
        document.body.appendChild(tag);
    });
};